import React from 'react';
import { Button } from './ui/Button';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="min-h-[90vh] flex items-center justify-center bg-warm-bg py-20 px-4" data-id="element-73">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center" data-id="element-74">
        <div className="space-y-8 text-center lg:text-left" data-id="element-75">
          <p className="font-heading tracking-[0.3em] text-xs text-warm-mid uppercase" data-id="element-76">
            Guía en PDF para padres
          </p>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-warm-dark leading-[1.05]" data-id="element-77">
            MENTE DE CAMPEÓN INQUEBRANTABLE
          </h1>

          <p className="text-lg md:text-xl font-heading font-medium text-warm-mid leading-snug" data-id="element-78">
            El Método de 3 Minutos para Atletas Juveniles
          </p>

          <p className="text-base text-warm-mid max-w-lg mx-auto lg:mx-0 leading-relaxed" data-id="element-79">
            Ayuda a tu hijo/a a superar el miedo al fracaso, eliminar el
            autosabotaje y recuperar la confianza en el deporte (incluso después
            de un error crítico).
          </p>

          <div className="pt-4" data-id="element-80">
            <Button className="w-full sm:w-auto" onClick={() => document.getElementById('oferta')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-81">
              Quiero ayudar a mi hijo ahora
              <ArrowRightIcon className="w-5 h-5" data-id="element-82" />
            </Button>
          </div>
        </div>

        <div className="mx-auto w-full max-w-md lg:max-w-full" data-id="element-83">
          <img src="https://cdn.magicpatterns.com/uploads/1WSyFrSao2CF5DLJvyKK6j/heylloyd-image-1772653878930.png" alt="Mente de Campeón Inquebrantable Cover" className="w-full h-auto object-contain" data-id="element-84" />
        </div>
      </div>
    </section>;
}